import React, { Component } from "react";
import { getStaticText } from '../../../lables/lablesService';
import ImageInput from '../../../components/image-input-component/imageInput';
import HtmlInput from '../../../components/html-input-component/htmlInput';
import DriversSchoolCategories from '../api/driversSchoolCategories';


class CategoryForm extends Component {


    constructor(props){
        super(props);

        this.save_type_process = false;
        this.state = {
            'increment' : 0
        };
    }


    changeInfoImage ( image_name, image ) {
        this.props.info.image_name = image_name;
        this.props.info.image = image;
        this.setState({
            'increment' : this.state.increment + 1
        });
    }


    changeInfoValue ( prop_name, prop_value ) {
    	let value = null;
        switch (prop_name) {
            case 'description':
                    value = prop_value;
                break;

            case 'active':
                    value = prop_value.target.checked ? 1 : 0;
                break;

            default:
                    value = prop_value.target.value
                break;
        }
        this.props.info[prop_name] = value;
    }


    async savePost () {
    	if ( this.save_type_process )
            return false;

        this.save_type_process = true;
        const formData = new FormData();

        if ( this.props.info.id > 0 )
            formData.append( 'id', this.props.info.id );

        if ( typeof(this.props.info.image) === 'object' )
            formData.append( 'image', this.props.info.image );

        formData.append( 'name', this.props.info.name );
        formData.append( 'description', this.props.info.description );
        formData.append( 'active', this.props.info.active );
        formData.append( 'position', this.props.info.position );

        let result = null;
        if ( this.props.info.id === 0 )
            result = await DriversSchoolCategories.add( formData );
        else
            result = await DriversSchoolCategories.update( formData );
    
        if ( !result ) {
            window.alert( getStaticText('save_error') );
        } else {
            window.alert( getStaticText('save_success') );
            if ( typeof(this.props.formCallback) === 'function' )
            	this.props.formCallback();
        }

        this.save_type_process = false;
    }


	render () {
		return (<>

                <ImageInput 
                    label={getStaticText('ttoc_form_image_input_label')}
                    fileImage={this.props.info.image || null}
                    fileName={this.props.info.image_name || null}
                    handleFile={this.changeInfoImage.bind(this)}
                />

                <div className="form-group">
                    <label
                        htmlFor="vcNameInput"
                    >
                        {getStaticText('ttoc_form_title_input_label')}
                    </label>
                    <input 
                        id="vcNameInput"
                        className="form-control"
                        defaultValue={this.props.info.name}
                        onChange={this.changeInfoValue.bind(this, 'name')}
                    />
                </div>

                <HtmlInput 
                    label={getStaticText('ttoc_form_description_input_label')}
                    content={this.props.info.description}
                    inputName="description"
                    onChangeContent={this.changeInfoValue.bind(this)}
                />

                <div className="form-group">
                    <label
                        htmlFor="vcPositionInput"
                    >
                        {getStaticText('ttoc_form_position_input_label')}
                    </label>
                    <input 
                        id="vcPositionInput"
                        className="form-control"
                        defaultValue={this.props.info.position}
                        onChange={this.changeInfoValue.bind(this, 'position')}
                    />
                </div>

                <div className="form-group">
                    <label>
                        <input 
                            type="checkbox"
                            defaultChecked={this.props.info.active}
                            onChange={this.changeInfoValue.bind(this, 'active')}
                        /> {getStaticText('ttoc_form_active_input_label')}
                    </label>
                </div>

                <div className="form-group os-text-right">
                    <button
                        className="btn btn-success"
                        onClick={this.savePost.bind(this)}
                    >
                        {this.props.info.id ? getStaticText('ttoc_form_update_button_label') : getStaticText('ttoc_form_add_button_label')}
                    </button>
                </div>
			</>);
	}

}


export default CategoryForm;